namespace GeniuzPOS.Purchase {
    export interface PoPurRequestForm {
        SysDocNo: Serenity.StringEditor;
        PurDocNo: Serenity.StringEditor;
        ShopId: Serenity.StringEditor;
        DocNo: Serenity.StringEditor;
        DocDate: Serenity.DateEditor;
        SupplierId: Serenity.LookupEditor;
        RefDocNo1: Serenity.StringEditor;
        RefDocNo2: Serenity.StringEditor;
        BranchCode: Serenity.StringEditor;
        ShipId: Serenity.LookupEditor;
        ShipDate: Serenity.DateEditor;
        WhsId: Serenity.StringEditor;
        ShipName: Serenity.StringEditor;
        PayTermCode: Serenity.LookupEditor;
        ShipLineAddress1: Serenity.StringEditor;
        ShipLineAddress2: Serenity.StringEditor;
        ShipLineAddress3: Serenity.StringEditor;
        VatFg: Serenity.RadioButtonEditor;
        POTypeFg: Serenity.RadioButtonEditor;
        SalesVatTypes: Serenity.LookupEditor;
        DtList: PoPurRequestDtEditor;
        Remark: Serenity.StringEditor;
        TotalAmt: Serenity.DecimalEditor;
        DiscText: Serenity.StringEditor;
        DiscAmt: Serenity.DecimalEditor;
        NetAmt: Serenity.DecimalEditor;
        NetExVat: Serenity.DecimalEditor;
        VatCode: Serenity.LookupEditor;
        VatRate: Serenity.DecimalEditor;
        VatAmt: Serenity.DecimalEditor;
        PurOrderAmt: Serenity.DecimalEditor;
        NetTotalInVat: Serenity.DecimalEditor;
        ApproveFg: Serenity.IntegerEditor;
        SendForAppfg: Serenity.EnumEditor;
        CancelFg: Serenity.EnumEditor;
    }

    export class PoPurRequestForm extends Serenity.PrefixedContext {
        static formKey = 'Purchase.PoPurRequest';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PoPurRequestForm.init)  {
                PoPurRequestForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;
                var w2 = s.LookupEditor;
                var w3 = s.RadioButtonEditor;
                var w4 = PoPurRequestDtEditor;
                var w5 = s.DecimalEditor;
                var w6 = s.IntegerEditor;
                var w7 = s.EnumEditor;

                Q.initFormType(PoPurRequestForm, [
                    'SysDocNo', w0,
                    'PurDocNo', w0,
                    'ShopId', w0,
                    'DocNo', w0,
                    'DocDate', w1,
                    'SupplierId', w2,
                    'RefDocNo1', w0,
                    'RefDocNo2', w0,
                    'BranchCode', w0,
                    'ShipId', w2,
                    'ShipDate', w1,
                    'WhsId', w0,
                    'ShipName', w0,
                    'PayTermCode', w2,
                    'ShipLineAddress1', w0,
                    'ShipLineAddress2', w0,
                    'ShipLineAddress3', w0,
                    'VatFg', w3,
                    'POTypeFg', w3,
                    'SalesVatTypes', w2,
                    'DtList', w4,
                    'Remark', w0,
                    'TotalAmt', w5,
                    'DiscText', w0,
                    'DiscAmt', w5,
                    'NetAmt', w5,
                    'NetExVat', w5,
                    'VatCode', w2,
                    'VatRate', w5,
                    'VatAmt', w5,
                    'PurOrderAmt', w5,
                    'NetTotalInVat', w5,
                    'ApproveFg', w6,
                    'SendForAppfg', w7,
                    'CancelFg', w7
                ]);
            }
        }
    }
}
